interface Properties {
  width?: number;
  height?: number;
  color?: string;
}

/** Figma "Dimensions" nav-tab icon (list-tree). */
const FigmaDimensionsIcon = ({ width = 16, height = 16, color = '#121826' }: Properties) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox='0 0 120 120'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M120 60C120 62.76 117.76 65 115 65H90C87.24 65 85 62.76 85 60C85 57.24 87.24 55 90 55H115C117.76 55 120 57.24 120 60ZM115 100H90C87.24 100 85 102.24 85 105C85 107.76 87.24 110 90 110H115C117.76 110 120 107.76 120 105C120 102.24 117.76 100 115 100ZM50 20H115C117.76 20 120 17.76 120 15C120 12.24 117.76 10 115 10H50C47.24 10 45 12.24 45 15C45 17.76 47.24 20 50 20ZM70 55V65C70 70.515 65.515 75 60 75H50C44.485 75 40 70.515 40 65H20V90C20 95.515 24.485 100 30 100H40C40 94.485 44.485 90 50 90H60C65.515 90 70 94.485 70 100V110C70 115.515 65.515 120 60 120H50C44.485 120 40 115.515 40 110H30C18.97 110 10 101.03 10 90V30C4.485 30 0 25.515 0 20V10C0 4.485 4.485 0 10 0H20C25.515 0 30 4.485 30 10V20C30 25.515 25.515 30 20 30V55H40C40 49.485 44.485 45 50 45H60C65.515 45 70 49.485 70 55Z'
        fill={color}
      />
    </svg>
  );
};

export default FigmaDimensionsIcon;
